import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const selectionModalHeader = css`
  margin-right: ${theme.spacing(3)};
  margin-left: ${theme.spacing(3)};
`;

export const selectionModalListbox = css`
  overflow-y: auto;
  padding-top: ${theme.spacing(1)};

  > div:first-of-type,
  li {
    padding-bottom: ${theme.spacing(1)};
    padding-right: ${theme.spacing(3)};
    padding-left: ${theme.spacing(3)};
  }
`;

export const selectionModalListboxSingleSelect = css`
  margin-bottom: 0;

  ul {
    margin-bottom: 0;
  }
`;

export const selectionModalListboxNotSearchable = css`
  margin-top: 0;
`;

export const selectionModalButtonBar = css`
  padding: ${theme.spacing(0, 3)};
`;

export const selectionModalBox = css`
  padding: ${theme.spacing(3, 0)};
`;

export const selectionModalBoxWithHeight = css`
  height: var(--selection-modal-height);
`;
